/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Common_Nochangesfound3Inputs */

const id_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada perubahan yang ditemukan untuk penawaran ini`)
};

const ms_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada perubahan ditemui untuk tawaran ini`)
};

const da_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ændringer fundet for dette tilbud`)
};

const de_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Änderungen für dieses Angebot gefunden`)
};

const en_us2_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes found for this offer`)
};

const es_es2_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron cambios para esta oferta de catálogo`)
};

const es_mx2_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron cambios para esta oferta`)
};

const fil_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang pagbabago para sa offer na ito`)
};

const fr_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune modification trouvée pour cette offre de catalogue`)
};

const it_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna modifica trovata per questa offerta`)
};

const hu_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található változás ehhez az ajánlathoz`)
};

const nl_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen wijzigingen gevonden voor dit aanbod`)
};

const no_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen endringer funnet for dette tilbudet`)
};

const pl_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono zmian dla tej oferty`)
};

const pt_br2_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma alteração encontrada para esta oferta de catálogo`)
};

const pt_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma alteração encontrada para esta oferta`)
};

const ro_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit modificări pentru această ofertă`)
};

const fi_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tälle tarjoukselle ei löytynyt muutoksia`)
};

const sv_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga ändringar hittades för detta erbjudande`)
};

const vi_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thay đổi nào cho ưu đãi này`)
};

const tr_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu teklif için değişiklik bulunamadı`)
};

const cs_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tuto nabídku nebyly nalezeny žádné změny`)
};

const bg_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени промени за тази оферта`)
};

const ru_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этого предложения не найдено изменений`)
};

const uk_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для цієї пропозиції змін не знайдено`)
};

const ar_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على تغييرات لهذا العرض`)
};

const hi_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ऑफ़र के लिए कोई बदलाव नहीं मिला`)
};

const th_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบการเปลี่ยนแปลงสำหรับข้อเสนอนี้`)
};

const ja_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオファーに変更は見つかりません`)
};

const zh_cn2_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此目录项无更改记录`)
};

const zh_hant1_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此目錄項目無變更記錄`)
};

const ko_offerdetail_common_nochangesfound3 = /** @type {(inputs: Offerdetail_Common_Nochangesfound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 오퍼에 대한 변경 사항이 없습니다`)
};

/**
* | output |
* | --- |
* | "No changes found for this offer" |
*
* @param {Offerdetail_Common_Nochangesfound3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_common_nochangesfound3 = /** @type {((inputs?: Offerdetail_Common_Nochangesfound3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Common_Nochangesfound3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_common_nochangesfound3(inputs)
	if (locale === "ms") return ms_offerdetail_common_nochangesfound3(inputs)
	if (locale === "da") return da_offerdetail_common_nochangesfound3(inputs)
	if (locale === "de") return de_offerdetail_common_nochangesfound3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_common_nochangesfound3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_common_nochangesfound3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_common_nochangesfound3(inputs)
	if (locale === "fil") return fil_offerdetail_common_nochangesfound3(inputs)
	if (locale === "fr") return fr_offerdetail_common_nochangesfound3(inputs)
	if (locale === "it") return it_offerdetail_common_nochangesfound3(inputs)
	if (locale === "hu") return hu_offerdetail_common_nochangesfound3(inputs)
	if (locale === "nl") return nl_offerdetail_common_nochangesfound3(inputs)
	if (locale === "no") return no_offerdetail_common_nochangesfound3(inputs)
	if (locale === "pl") return pl_offerdetail_common_nochangesfound3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_common_nochangesfound3(inputs)
	if (locale === "pt") return pt_offerdetail_common_nochangesfound3(inputs)
	if (locale === "ro") return ro_offerdetail_common_nochangesfound3(inputs)
	if (locale === "fi") return fi_offerdetail_common_nochangesfound3(inputs)
	if (locale === "sv") return sv_offerdetail_common_nochangesfound3(inputs)
	if (locale === "vi") return vi_offerdetail_common_nochangesfound3(inputs)
	if (locale === "tr") return tr_offerdetail_common_nochangesfound3(inputs)
	if (locale === "cs") return cs_offerdetail_common_nochangesfound3(inputs)
	if (locale === "bg") return bg_offerdetail_common_nochangesfound3(inputs)
	if (locale === "ru") return ru_offerdetail_common_nochangesfound3(inputs)
	if (locale === "uk") return uk_offerdetail_common_nochangesfound3(inputs)
	if (locale === "ar") return ar_offerdetail_common_nochangesfound3(inputs)
	if (locale === "hi") return hi_offerdetail_common_nochangesfound3(inputs)
	if (locale === "th") return th_offerdetail_common_nochangesfound3(inputs)
	if (locale === "ja") return ja_offerdetail_common_nochangesfound3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_common_nochangesfound3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_common_nochangesfound3(inputs)
	return ko_offerdetail_common_nochangesfound3(inputs)
});
export { offerdetail_common_nochangesfound3 as "offerDetail.common.noChangesFound" }